var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_vm._m(0),_c('small',[_vm._v(" Copyright © 2019-"+_vm._s(_vm.copyright_year)+" imgzo.cn All Rights Reserved.")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('small',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2022008840号")]),_vm._v(" ")])
}]

export { render, staticRenderFns }